import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const eocGlobalGroupDetailRoute: InvariantJiraRoute = {
	name: 'eoc-global-group-detail',
	path: '/jira/ops/group-detail/:id',
	exact: true,
};
